export default __webpack_public_path__ + "static/media/eyepatch.c9ee63b1.jpg";